import axios from "axios";
import { domain } from "../../Links/Links";
import { getCookie } from "../../../App";

export async function removeToShoppingCartRequest(
  setQuantityInShoppingCart,
  link,
  setAddToShoppingCartRequestStatus,
) {

  setAddToShoppingCartRequestStatus(true);

  console.log(link);

  const data = {
    link: link,
  };
  const response = await axios.post(
    domain + "/remove_shopping_cart/",
    data,
    {
      withCredentials: true,
      headers: {
        "X-CSRFToken": getCookie("csrf_token"),
      },
    },
  );

  console.log(response.data.quantity_in_shopping_cart)

  if (response.data.quantity_in_shopping_cart !== undefined) {
    setQuantityInShoppingCart(response.data.quantity_in_shopping_cart);
    setAddToShoppingCartRequestStatus(false);
  }
}
